import { registerBlockType } from "@wordpress/blocks"
import Edit from "./edit"

registerBlockType("puroclean/hero-section", {
  edit: Edit,
  save: () => null // Server-side rendered block
}) 